/**
 * YQ Product Mega — hover updates View all URL only (no sticky active nav state).
 * Open/close remains on mega-menu-disclosure (details).
 */
(() => {
  if (customElements.get('yq-product-mega')) return;

  class YqProductMega extends HTMLElement {
    connectedCallback() {
      this._onTriggerEnter = this._onTriggerEnter.bind(this);
      this._triggers = Array.from(this.querySelectorAll('[data-yq-mega-trigger]'));
      this._viewAll = this.querySelector('[data-yq-mega-view-all]');

      this._triggers.forEach((trigger) => {
        trigger.addEventListener('pointerenter', this._onTriggerEnter);
        trigger.addEventListener('focus', this._onTriggerEnter);
      });
    }

    disconnectedCallback() {
      this._triggers?.forEach((trigger) => {
        trigger.removeEventListener('pointerenter', this._onTriggerEnter);
        trigger.removeEventListener('focus', this._onTriggerEnter);
      });
    }

    _onTriggerEnter(event) {
      this._syncViewAll(event.currentTarget);
    }

    _syncViewAll(trigger) {
      if (!this._viewAll || !trigger || this._viewAll.hasAttribute('data-yq-mega-view-locked')) return;
      const url = trigger.getAttribute('data-yq-mega-view-url');
      if (url) this._viewAll.setAttribute('href', url);
    }
  }

  customElements.define('yq-product-mega', YqProductMega);
})();
